import { useAnimate, useInView } from "framer-motion";
import React, { useEffect } from "react";

const STEPS = [
  {
    Icon: <img src="/assets/imgs/stepper/discover.png" alt="Discover" />,
    text: "Discover",
    tooltip:
      "Understanding people, context, and problems before designing solutions.",
  },
  {
    Icon: <img src="/assets/imgs/stepper/define.png" alt="Define" />,
    text: "Define",
    tooltip:
      "Translating insights into clear, actionable design opportunities.",
  },
  {
    Icon: <img src="/assets/imgs/stepper/design.png" alt="Design" />,
    text: "Develop",
    tooltip: "Exploring ideas fearlessly and shaping them through iteration.",
  },
  {
    Icon: <img src="/assets/imgs/stepper/deliver.png" alt="Deliver" />,
    text: "Deliver",
    tooltip: "Transforming validated concepts into impactful user experiences.",
  },
];

export const Stepper = () => {
  const [scope, animate] = useAnimate();
  const inView = useInView(scope, { once: true });

  useEffect(() => {
    const handleAnimate = async () => {
      for (let i = 0; i < STEPS.length; i++) {
        animate(
          `[data-iconid="icon-${i}"]`,
          {
            opacity: [0.25, 1],
          },
          {
            duration: 0.2,
            ease: "linear",
          }
        );
        if (i !== STEPS.length - 1) {
          await animate(
            `[data-lineid="line-${i}"]`,
            {
              scaleX: [0, 1],
            },
            {
              duration: 0.2,
              ease: "linear",
              delay: 0.1,
            }
          );
        }
      }
    };
    inView && handleAnimate();
  }, [animate, inView]);

  return (
    <div ref={scope} className="stepper-container pt-40 pb-40">
      {STEPS.map((s, i) => {
        return (
          <React.Fragment key={i}>
            {/* <div className="stepper-item">
              <span data-iconid={`icon-${i}`} className="steppeer-item-icon">
                {s.Icon}
              </span>
              <span className="steppeer-item-text tooltip-container">
                {s.text}
                <span class="tooltip">{s.tooltip}</span>
              </span>
            </div> */}
            <div className="stepper-card">
              <div className="stepper-card-inner">
                <div className="front-face">
                  <div className="stepper-item">
                    <span
                      data-iconid={`icon-${i}`}
                      className="steppeer-item-icon"
                    >
                      {s.Icon}
                    </span>
                    <span className="steppeer-item-text tooltip-container">
                      {s.text}
                    </span>
                  </div>
                </div>
                <div className="back-face">{s.tooltip}</div>
              </div>
            </div>
            {i !== STEPS.length - 1 && (
              <div className="steppeer-line-container">
                <div data-lineid={`line-${i}`} className="steppeer-line" />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
